function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n    .redcircle-shadow{fill:url(#radial-gradient);}\r\n    .redcircle,.red-j{fill:#bf1212;}\r\n    .innercircle-shadow{fill:url(#radial-gradient-2);}\r\n    .innercircle{fill:#fff;}\r\n    .j-shadow{fill:#aaa9ac;opacity:0.4;}\r\n  "), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient",
  cx: 511.51,
  cy: 512.51,
  r: 510.51,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.86,
  stopOpacity: 0.53
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-2",
  cx: 514.32,
  cy: 514.64,
  r: 383.68,
  xlinkHref: "#radial-gradient"
}));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "JasperactiveIcon");

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  className: "redcircle-shadow",
  cx: 511.51,
  cy: 512.51,
  r: 510.51
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  className: "redcircle",
  cx: 511.51,
  cy: 514.11,
  r: 467.07
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  className: "innercircle-shadow",
  cx: 514.32,
  cy: 514.64,
  r: 383.68
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  className: "innercircle",
  cx: 511.51,
  cy: 513.57,
  r: 365.51
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "j-shadow",
  d: "M621.14,585.82c0,73.38-19,142.84-126.59,142.84-62.74,0-108.67-29.13-121.55-92.42,0,0,100.26,15.12,119.31,15.12,40.89,0,41.45-45.37,41.45-75.06V322h87.38Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "red-j",
  d: "M609.22,574c0,73.92-19.18,143.88-127.51,143.88-63.19,0-109.46-29.34-122.43-93.1L440,605c2.25,19.19,20.31,35,39.49,35,41.19,0,41.75-45.71,41.75-75.61V308.24h88Z"
});

var SvgJasperactiveIcon = function SvgJasperactiveIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "JasperactiveIcon",
    "data-name": "Jasperactive Icon",
    viewBox: "0 0 1024 1024",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJasperactiveIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/jasperactive-icon.4ff58133.svg";
export { ForwardRef as ReactComponent };